export default ({ router, next }) => {

    if (localStorage.getItem('turismo_empresa'))
        return router.push({ name: 'dashboard' });

    return next();

}